import React from "react";
import { Blog } from "../../components/Blogs/Blogs";

export const Blogs = () => {
  return (
    <div>
      <Blog />
    </div>
  );
};
